<template>
  <div class="infinitescrolltrigger">
    <div ref="infinitescrolltrigger" class="scroll-trigger text-center">
      <LoadingComponent v-if="isBussy" />
    </div>
  </div>
</template>

<script>
// import PageHeader from "@/components/header/PageHeader";
import LoadingComponent from "../loading/LoadingComponent.vue";
import "@/mixins";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["isSearching"],
  components: {
    LoadingComponent,
  },
  computed: {
    ...mapGetters(["tradeHistory"]),

    currentPage: {
      get() {
        return this.$store.state.tradeHistoryCurrentPage;
      },

      set(value) {
        return (this.$store.state.tradeHistoryCurrentPage = value);
      },
    },

    totalPage: {
      get() {
        return this.$store.state.tradeHistoryTotalPage;
      },

      set(value) {
        return (this.$store.state.tradeHistoryTotalPage = value);
      },
    },
  },

  data() {
    return {
      isBussy: false,
      totalPages: 2,
    };
  },

  methods: {
    ...mapActions(["fetchMoreTrade", "saveMoreTrade"]),

    scrollTrigger: function () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.intersectionRatio > 0 &&
            this.currentPage < this.totalPage &&
            this.tradeHistory.length > 0
          ) {
            this.isBussy = true;
            this.currentPage += 1;
            this.fetchTrade(this.currentPage);
          }
        });
      });

      observer.observe(this.$refs.infinitescrolltrigger);
    },

    fetchTrade: function (currentPage) {
      // console.log(payload);

      this.fetchMoreTrade(currentPage)
        .then((response) => {
          this.isBussy = false;
          if (!response.error) {
            this.saveMoreTrade(response.data.data);

            this.currentPage = response.data.meta.page;
            this.totalPage = response.data.meta.pages;
          }
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.scrollTrigger();
  },
};
</script>
<style scoped>
.infinitescrolltrigger {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scroll-trigger {
  margin-top: 0px;
  text-align: center;
}

[class*="loader"]:before {
  content: "fetching more...";
}
</style>
